import React from "react";
import { Container, Row } from "reactstrap";
import LeftTodo from "./LeftTodo";
import RightTodo from "./RightTodo";
import { TodoFilterProvider } from "../../../Features/todo/context/TodoFilterContext";

export default function ToDoContainer() {
  return (
    <TodoFilterProvider>
      <Container fluid className="email-wrap bookmark-wrap todo-wrap px-0 mx-0 section-todo">
        <Row>
          <LeftTodo />
          <RightTodo />
        </Row>
      </Container>
    </TodoFilterProvider>
  );
}
